"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RegionInfo = exports.CountryInfo = exports.USStateKind = exports.ProductTypeKind = exports.AgencyTypeKind = exports.DataFeedKind = exports.CallAlertKind = void 0;
/** @module models */
var cerealParse_1 = require("../cerealParse");
/** Use call alert kind for new agency. */
var CallAlertKind;
(function (CallAlertKind) {
    CallAlertKind[CallAlertKind["Unknown"] = 0] = "Unknown";
    CallAlertKind[CallAlertKind["True"] = 1] = "True";
    CallAlertKind[CallAlertKind["False"] = 2] = "False";
})(CallAlertKind || (exports.CallAlertKind = CallAlertKind = {}));
/** Data feed kind for new agency. */
var DataFeedKind;
(function (DataFeedKind) {
    DataFeedKind[DataFeedKind["Unknown"] = 0] = "Unknown";
    DataFeedKind[DataFeedKind["Email"] = 1] = "Email";
    DataFeedKind[DataFeedKind["SMS"] = 2] = "SMS";
    DataFeedKind[DataFeedKind["MDT"] = 3] = "MDT";
    DataFeedKind[DataFeedKind["SNPP"] = 4] = "SNPP";
    DataFeedKind[DataFeedKind["Other"] = 5] = "Other";
})(DataFeedKind || (exports.DataFeedKind = DataFeedKind = {}));
/** Agency type for lead. */
var AgencyTypeKind;
(function (AgencyTypeKind) {
    AgencyTypeKind[AgencyTypeKind["fire"] = 0] = "fire";
    AgencyTypeKind[AgencyTypeKind["ems"] = 1] = "ems";
    AgencyTypeKind[AgencyTypeKind["police"] = 2] = "police";
    AgencyTypeKind[AgencyTypeKind["psap"] = 3] = "psap";
    AgencyTypeKind[AgencyTypeKind["security"] = 4] = "security";
    AgencyTypeKind[AgencyTypeKind["military"] = 5] = "military";
    AgencyTypeKind[AgencyTypeKind["publicWorks"] = 6] = "publicWorks";
    AgencyTypeKind[AgencyTypeKind["other"] = 7] = "other";
})(AgencyTypeKind || (exports.AgencyTypeKind = AgencyTypeKind = {}));
/** Product type for lead. */
var ProductTypeKind;
(function (ProductTypeKind) {
    ProductTypeKind["bryx911"] = "bryx911";
    ProductTypeKind["bryxStation"] = "bryxStation";
    ProductTypeKind["bryxHospital"] = "bryxHospital";
})(ProductTypeKind || (exports.ProductTypeKind = ProductTypeKind = {}));
/** US states for lead. */
var USStateKind;
(function (USStateKind) {
    USStateKind[USStateKind["al"] = 0] = "al";
    USStateKind[USStateKind["ak"] = 1] = "ak";
    USStateKind[USStateKind["az"] = 2] = "az";
    USStateKind[USStateKind["ar"] = 3] = "ar";
    USStateKind[USStateKind["ca"] = 4] = "ca";
    USStateKind[USStateKind["co"] = 5] = "co";
    USStateKind[USStateKind["ct"] = 6] = "ct";
    USStateKind[USStateKind["de"] = 7] = "de";
    USStateKind[USStateKind["fl"] = 8] = "fl";
    USStateKind[USStateKind["ga"] = 9] = "ga";
    USStateKind[USStateKind["hi"] = 10] = "hi";
    USStateKind[USStateKind["id"] = 11] = "id";
    USStateKind[USStateKind["il"] = 12] = "il";
    USStateKind[USStateKind["in"] = 13] = "in";
    USStateKind[USStateKind["ia"] = 14] = "ia";
    USStateKind[USStateKind["ks"] = 15] = "ks";
    USStateKind[USStateKind["ky"] = 16] = "ky";
    USStateKind[USStateKind["la"] = 17] = "la";
    USStateKind[USStateKind["me"] = 18] = "me";
    USStateKind[USStateKind["md"] = 19] = "md";
    USStateKind[USStateKind["ma"] = 20] = "ma";
    USStateKind[USStateKind["mi"] = 21] = "mi";
    USStateKind[USStateKind["mn"] = 22] = "mn";
    USStateKind[USStateKind["ms"] = 23] = "ms";
    USStateKind[USStateKind["mo"] = 24] = "mo";
    USStateKind[USStateKind["mt"] = 25] = "mt";
    USStateKind[USStateKind["ne"] = 26] = "ne";
    USStateKind[USStateKind["nv"] = 27] = "nv";
    USStateKind[USStateKind["nh"] = 28] = "nh";
    USStateKind[USStateKind["nj"] = 29] = "nj";
    USStateKind[USStateKind["nm"] = 30] = "nm";
    USStateKind[USStateKind["ny"] = 31] = "ny";
    USStateKind[USStateKind["nc"] = 32] = "nc";
    USStateKind[USStateKind["nd"] = 33] = "nd";
    USStateKind[USStateKind["oh"] = 34] = "oh";
    USStateKind[USStateKind["ok"] = 35] = "ok";
    USStateKind[USStateKind["or"] = 36] = "or";
    USStateKind[USStateKind["pa"] = 37] = "pa";
    USStateKind[USStateKind["ri"] = 38] = "ri";
    USStateKind[USStateKind["sc"] = 39] = "sc";
    USStateKind[USStateKind["sd"] = 40] = "sd";
    USStateKind[USStateKind["tn"] = 41] = "tn";
    USStateKind[USStateKind["tx"] = 42] = "tx";
    USStateKind[USStateKind["ut"] = 43] = "ut";
    USStateKind[USStateKind["vt"] = 44] = "vt";
    USStateKind[USStateKind["va"] = 45] = "va";
    USStateKind[USStateKind["wa"] = 46] = "wa";
    USStateKind[USStateKind["wv"] = 47] = "wv";
    USStateKind[USStateKind["wi"] = 48] = "wi";
    USStateKind[USStateKind["wy"] = 49] = "wy";
    USStateKind[USStateKind["other"] = 50] = "other";
})(USStateKind || (exports.USStateKind = USStateKind = {}));
/**
 * CountryInfo class.
 */
var CountryInfo = /** @class */ (function () {
    /**
     * Create country info object.
     * @param code Two character country code.
     * @param name Country name.
     */
    function CountryInfo(code, name) {
        this.code = code;
        this.name = name;
    }
    /**
     * Parse country info.
     * @param Object to parse.
     * @return Parse result.
     */
    CountryInfo.parse = function (o) {
        try {
            return cerealParse_1.ParseUtils.parseSuccess(new CountryInfo(cerealParse_1.ParseUtils.getString(o, 'code'), cerealParse_1.ParseUtils.getString(o, 'name')));
        }
        catch (e) {
            return cerealParse_1.ParseUtils.parseFailure("Invalid CountryInfo: ".concat(e.message));
        }
    };
    return CountryInfo;
}());
exports.CountryInfo = CountryInfo;
/**
 * RegionInfo class.
 * Represents information about a region of a country.
 */
var RegionInfo = /** @class */ (function () {
    /**
     * Create region info object.
     * @param code Region code.
     * @param name Region name.
     */
    function RegionInfo(code, name) {
        this.code = code;
        this.name = name;
    }
    /**
     * Parse region info.
     * @param Object to parse.
     * @return Parse result.
     */
    RegionInfo.parse = function (o) {
        try {
            return cerealParse_1.ParseUtils.parseSuccess(new RegionInfo(cerealParse_1.ParseUtils.getString(o, 'code'), cerealParse_1.ParseUtils.getString(o, 'name')));
        }
        catch (e) {
            return cerealParse_1.ParseUtils.parseFailure("Invalid RegionyInfo: ".concat(e.message));
        }
    };
    return RegionInfo;
}());
exports.RegionInfo = RegionInfo;
//# sourceMappingURL=lead.js.map